<template>
  <div class="add-btn" @click.stop="handleClick">
    <v-icon size="12">fa-solid fa-plus</v-icon>
  </div>
</template>

<script>
export default {
  name: 'AddBtn',
  data: () => ({}),
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>


<style scoped>
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px; 
  height: 24px; 
  background-color: rgba(237, 237, 241, 1); 
  border-radius: 4px; 
  padding: 4px;
  cursor: pointer;
  transition: 0.3s ease;
}

.add-btn:hover {
  background-color: #CBCBCE;
}
</style>